export interface TranslationSubstitutions {
	[key: string]: string;
}

export interface ImpulseError {
	message: string;
	substitutions?: TranslationSubstitutions;
}

/**
 * The type of the response that comes back if an angular HTTP call to our backend fails.
 */
export interface ImpulseErrorHTTPResponse {
	error: ImpulseError;
}

export function isImpulseError(error: any): error is ImpulseError {
	return (<ImpulseError>error).message !== undefined;
}

export function isImpulseErrorHTTPResponse(error: any): error is ImpulseErrorHTTPResponse {
	return typeof error.error === "object" && typeof error.error.message === "string";
}
